<template>
	<view class="box">
		<view class="box_info">
			<view class="list">
				<view class="list_item" @click="openOrder">
					<view class="list_item_label">
						<text>退款原因</text>
						<text>*</text>
					</view>
					<view class="list_item_to">
						<text>请选择</text>
						<uni-icons type="forward" size="18" color="#999999"></uni-icons>
					</view>
				</view>
				<view class="list_price">
					<view class="list_price_box">
						<view class="list_price_box_top">
							<text>刘美女</text>
							<text>15789347769</text>
						</view>
						<view class="list_price_box_bottom">
							上海 上海市 青浦区 夏阳街道华科路新青浦家园
							144号楼101
						</view>
					</view>
					<view class="list_price_bottom">
						修改
					</view>
				</view>
			</view>
		</view>
		<view class="box_desc">
			<view class="box_desc_label">补充描述和凭证</view>
			<view class="box_desc_ipt">
				<textarea placeholder="补充描述，有助于商家更好的处理售后问题"></textarea>
				<view class="box_desc_ipt_list">
					<view class="box_desc_ipt_list_item">
						<image src="@/static/icon/ic_pingzheng@2x.png" mode="widthFix"></image>
					</view>
				</view>
			</view>
		</view>
		<view class="box_zw"></view>
		<view class="box_footer">
			<view class="box_footer_btn">提交</view>
		</view>
		<!-- 退款原因 -->
		<uni-popup ref="popup1" background-color="#fff">
			<view class="popup1">
				<view class="popup_head">
					<text></text>
					<text>退款原因</text>
					<uni-icons type="closeempty" @click="close" size="20" color="#999999"></uni-icons>
				</view>
				<view class="popup_list">
					<view class="popup_list_item" v-for="(item, index) in cates" :key="index" @click="changeCate(index)">
						<text>{{item.name}}</text>
						<radio color="#D20A0A" :value="item.id" :checked="index === current" />
					</view>
				</view>
				<view class="popup_footer">
					<view class="popup_footer_btn">确定</view>
				</view>
			</view>
		</uni-popup>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				current: 0,
				cates: [
					{ name: '卖家发错货', id: 1 },
					{ name: '质量问题', id: 2 },
					{ name: '商品破损/裂痕', id: 3 }
				]
			}
		},
		methods: {
			openOrder() {
				this.$refs.popup1.open('bottom')
			},
			close() {
				this.$refs.popup1.close()
			},
			changeCate(index) {
				this.current = index
			}
		}
	}
</script>

<style lang="scss" scoped>
	.box {
		width: 100%;
		.box_info {
			width: 100%;
			padding: 0 32rpx 28rpx 32rpx;
			box-sizing: border-box;
			background-color: #ffffff;
			.list {
				display: flex;
				flex-direction: column;
				width: 100%;
				.list_item {
					display: flex;
					align-items: center;
					justify-content: space-between;
					margin-top: 44rpx;
					.list_item_label {
						display: flex;
						align-items: center;
						text {
							&:nth-child(1) {
								font-size: 32rpx;
								font-family: PingFang SC-Medium, PingFang SC;
								font-weight: 500;
								color: #333333;
							}
							&:nth-child(2) {
								font-size: 32rpx;
								font-family: PingFang SC-Medium, PingFang SC;
								font-weight: 500;
								color: #D20A0A;
							}
						}
					}
					.list_item_to {
						display: flex;
						align-items: center;
						text {
							font-size: 28rpx;
							font-family: PingFang SC-Medium, PingFang SC;
							font-weight: 500;
							color: #999999;
							margin-right: 12rpx;
						}
					}
				}
				.list_price {
					margin-top: 52rpx;
					display: flex;
					align-items: center;
					justify-content: space-between;
					.list_price_box {
						flex: 1;
						display: flex;
						align-items: flex-start;
						flex-direction: column;
						.list_price_box_top {
							display: flex;
							align-items: center;
							text {
								&:nth-child(1) {
									font-size: 28rpx;
									font-family: PingFang SC-Semibold, PingFang SC;
									font-weight: 600;
									color: #333333;
									margin-right: 12rpx;
								}
								&:nth-child(2) {
									font-size: 24rpx;
									font-family: PingFang SC-Regular, PingFang SC;
									font-weight: 400;
									color: #999999;
								}
							}
						}
						.list_price_box_bottom {
							font-size: 24rpx;
							font-family: PingFang SC-Regular, PingFang SC;
							font-weight: 400;
							color: #333333;
							margin-top: 16rpx;
						}
					}
					.list_price_bottom {
						flex-shrink: 0;
						margin-left: 126rpx;
						font-size: 28rpx;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #333333;
					}
				}
			}
		}
		.box_desc {
			width: 100%;
			padding: 28rpx 32rpx;
			box-sizing: border-box;
			background-color: #ffffff;
			margin-top: 16rpx;
			.box_desc_label {
				font-size: 32rpx;
				font-family: PingFang SC-Semibold, PingFang SC;
				font-weight: 600;
				color: #333333;
				margin-bottom: 36rpx;
			}
			.box_desc_ipt {
				width: 100%;
				padding: 28rpx 24rpx;
				background-color: #F5F5F5;
				box-sizing: border-box;
				display: flex;
				flex-direction: column;
				textarea {
					width: 100%;
					height: 80rpx;
				}
				.box_desc_ipt_list {
					display: flex;
					align-items: center;
					flex-wrap: wrap;
					margin-top: 50rpx;
					.box_desc_ipt_list_item {
						width: 172rpx;
						height: 172rpx;
						image {
							width: 100%;
							height: 100%;
						}
					}
				}
			}
		}
		.box_zw {
			width: 100%;
			height: calc(112rpx + env(safe-area-inset-bottom));
		}
		.box_footer {
			width: 100%;
			position: fixed;
			bottom: 0;
			left: 0;
			box-sizing: border-box;
			background-color: #FFFFFF;
			padding: 20rpx 56rpx calc(20rpx + env(safe-area-inset-bottom)) 56rpx;
			.box_footer_btn {
				width: 100%;
				height: 72rpx;
				line-height: 72rpx;
				text-align: center;
				background: linear-gradient(270deg, #D20A0A 0%, #D95A5A 100%);
				border-radius: 36rpx;
				font-size: 32rpx;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #FFFFFF;
			}
		}
		.popup1 {
			padding: 48rpx 32rpx 0 32rpx;
			.popup_head {
				display: flex;
				align-items: center;
				justify-content: space-between;
				text {
					font-size: 32rpx;
					font-family: PingFang SC-Semibold, PingFang SC;
					font-weight: 600;
					color: #333333;
				}
			}
			.popup_list {
				width: 100%;
				display: flex;
				flex-direction: column;
				margin-top: 68rpx;
				.popup_list_item {
					display: flex;
					align-items: center;
					justify-content: space-between;
					margin-bottom: 62rpx;
					&:last-child {
						margin-bottom: 0 !important;
					}
					text {
						font-size: 28rpx;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #333333;
					}
				}
			}
			.popup_footer {
				padding: 0 24rpx 20rpx 24rpx;
				margin-top: 112rpx;
				.popup_footer_btn {
					width: 100%;
					height: 72rpx;
					line-height: 72rpx;
					text-align: center;
					background: linear-gradient(270deg, #D20A0A 0%, #D95A5A 100%);
					border-radius: 36rpx;
					font-size: 32rpx;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #FFFFFF;
				}
			}
		}
	}
</style>